var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PlaceholderFashion",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-placeholder-fashion","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M214.4 90.6c5.1-13.9 5.4-25.2 5.5-26.8.2-3.3-.6-6-2.4-7.9-1.7-1.8-3.9-2.5-5.5-2.5h-28c-18.4-33.5-38-50-58.3-49.2-29.3 1.3-49.2 38.6-54.2 49.2H38.3c-6.5 0-9.2 4.9-9.5 8.1v.4c0 .6.3 12.5 5.8 27.2-5.4 9.3-26.7 50.5-34.4 132l-.1 1.3.6 1.2c.4.8 2.3 3.8 8.1 7.4 7.3 4.6 17.8 8.3 31 10.9h.2c.6.1 40.4 5.6 89 5.6 24.4 0 51.1-1.4 76.1-5.6 3-.2 25.2-1.9 42.3-15.3l1.7-1.3.1-2.1c0-2.2 1.3-60.2-34.8-132.6zm-88.3-77.3c15.8-.7 31.7 12.8 47.6 40.2H81.6c6.5-12.5 23.1-39.3 44.5-40.2zM38.3 62.4h172.5v1.1c0 .2-.1 15.2-8.2 31.6-10.7 21.5-29.5 34.8-56.1 39.6v-12.3c0-4.7-3.8-8.5-8.5-8.5h-18.3c-4.7 0-8.5 3.8-8.5 8.5V135c-29.8-3.2-51.2-16.3-63.5-38.9-8.4-15.4-9.6-30.4-9.8-33.6.1 0 .2-.1.4-.1zm81.9 86.7v-26h17.3v26h-17.3zm4.6 9h7.3v7.7l-3.7 4.5-3.6-3.6v-8.6zm79.7 75l-.6.1c-72.2 12.2-158.9.5-162.5 0-21.9-4.3-29.8-10.6-32.1-12.9 6.5-66.4 22.5-105.3 30-120.6.1.1.1.3.2.4 9.6 17.8 29.7 39.9 71.6 44.1v5.5c0 3.3 1.9 6.2 4.7 7.6v13.3l13.4 13.1 12-14.5v-11.6c3.1-1.3 5.3-4.3 5.3-7.9V144c36.3-6.1 54.3-26.1 63.1-42.7C237.8 161 240 210.4 240.2 221c-15.5 11.1-35.5 12.1-35.7 12.1z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/placeholder-fashion.svg